<template>
  <v-container fluid mx-0 pa-0>
    <v-row style="max-width: 98%; margin: 0px auto">
      <v-btn color="primary" class="my-3" icon @click="Fct_AddEngage" title="Ajouter un engagement">
        <v-icon size="36">mdi-plus-circle</v-icon>
      </v-btn>
      <div class="ml-2 my-4" style="font-size: 1.2em">Liste des Engagements</div>
      <v-spacer />
      <v-text-field v-model="T_Search" append-icon="mdi-magnify" label="Rechercher" single-line hide-details class="mr-4"></v-text-field>
    </v-row>
    <v-row style="max-width: 98%; margin: 0px auto" class="mb-3">
      <v-spacer />
      <span class="d-inline-flex">
        <v-icon small class="mr-2 ml-3" title="Vous pouvez editer cette ligne" color="primary"> mdi-pencil </v-icon>
        <div class="mt-1" style="font-size: 0.9em">Editer</div>
        <v-icon small class="mr-2 ml-3" title="Vous pouvez editer cette ligne" color="primary"> mdi-eye </v-icon>
        <div class="mt-1" style="font-size: 0.9em">Visualiser</div>
        <v-icon small class="mr-2 ml-3" title="Un message a été renvoyé par l'approbateur"> mdi-message-processing-outline </v-icon>
        <div class="mt-1" style="font-size: 0.9em">Message</div>
        <v-icon small class="mr-2 ml-3" title="A envoyer pour appro"> mdi-timer-sand </v-icon>
        <div class="mt-1" style="font-size: 0.9em">A envoyer pour appro</div>
        <v-icon small class="mr-2 ml-3" title="Envoyé pour appro"> mdi-camera-timer </v-icon>
        <div class="mt-1" style="font-size: 0.9em">Envoyé pour appro</div>
        <v-icon small class="mr-2 ml-3" title="Approuvé" color="#00AA00"> mdi-check </v-icon>
        <div class="mt-1" style="font-size: 0.9em">Approuvé</div>
        <v-icon small class="mr-2 ml-3" title="Refusé" color="#AA0000"> mdi-close </v-icon>
        <div class="mt-1" style="font-size: 0.9em">Refusé</div>
        <v-icon small class="mr-2 ml-3" title="Expédié" color="primary"> mdi-email </v-icon>
        <div class="mt-1" style="font-size: 0.9em">Expédié</div>
      </span>
    </v-row>
    <v-data-table
      v-model="TO_Selected"
      :headers="headers"
      :items="filteredItems"
      :single-select="B_SingleSelect"
      :items-per-page="15"
      show-select
      :search="T_Search"
      show-expand
      :single-expand="true"
      :expanded.sync="TO_Expanded"
    >
      <template #item.provider="{ item }">
        <div>
          {{ item.provider }} <span style="color: #aaa">({{ item.code_frn }})</span>
        </div>
      </template>

      <template #item.search_ca="{ item }">
        <div>
          {{ item.libelle_CA }} <span style="color: #aaa">({{ item.code_CA }})</span>
        </div>
      </template>

      <template #item.search_na="{ item }">
        <div v-if="item.budgets.length == 1">
          {{ item.budgets[0].libelle_nature }} <span style="color: #aaa">({{ item.budgets[0].code_nature }})</span>
        </div>
        <div v-else>
          <v-tooltip bottom color="black" dark>
            <template v-slot:activator="{ on }">
              <span style="color: #336699;text-decoration: none" v-on="on">
                Natures multiples
              </span>
            </template>
            <template v-if="item.budgets.length > 1">
              <span v-html="renderBudgets(item.budgets)"></span>
            </template>
          </v-tooltip>
        </div>
      </template>

      <template #item.file="{ item }">
        <div>
          <a :href="item.file" target="_blank" title="Voir le fichier dans un autre onglet">Devis</a>
        </div>
      </template>

      <template #item.statutFact="{ item }">
        <v-icon small class="mr-2" title="Cet engagement n'a encore aucune facture liée" v-if="item.statutFact == 0"> mdi-checkbox-blank-outline </v-icon>
        <v-icon small class="mr-2" title="Cet engagement est partiellement facturé" v-if="item.statutFact == 1"> mdi-checkbox-intermediate </v-icon>
        <v-icon small class="mr-2" title="Cet engagement est totalement facturé" v-if="item.statutFact == 2"> mdi-checkbox-marked </v-icon>
      </template>

      <template #item.archive="{ item }">
        <v-icon small class="mr-2" title="Cet engagement est archivé" v-if="item.archive"> mdi-checkbox-marked </v-icon>
        <v-icon small class="mr-2" title="Cet engagement n'est pas archivé" v-else> mdi-checkbox-blank-outline </v-icon>
      </template>

      <template #item.action="{ item }">
        <v-icon small class="mr-2" title="Editer cette ligne" color="primary" v-if="item.fk_Statut < 4" @click="Fct_EditEngage(item.id)"> mdi-pencil </v-icon>
        <v-icon small class="mr-2" title="Visualiser cette ligne" color="primary" v-if="item.fk_Statut >= 4" @click="Fct_VisuEngage(item.id)"> mdi-eye </v-icon>
        <v-icon small class="mr-2" title="A envoyer pour appro" v-if="item.fk_Statut == 1"> mdi-timer-sand </v-icon>
        <v-icon small class="mr-2" title="Envoyé pour appro" v-if="item.fk_Statut == 2"> mdi-camera-timer </v-icon>
        <v-icon small class="mr-2" title="Approuvé" v-if="item.fk_Statut == 3" color="#00AA00"> mdi-check </v-icon>
        <v-icon small class="mr-2" title="Refusé" v-if="item.fk_Statut == 4" color="#AA0000"> mdi-close </v-icon>
        <v-icon small class="mr-2" title="Expédié" v-if="item.fk_Statut == 5" color="primary" @click="Fct_OpenFile(item.orderFile)"> mdi-email </v-icon>
        <v-icon small class="mr-2" title="Un message a été renvoyé par l'approbateur" v-if="item.commentaireApprobateur != ''"> mdi-message-processing-outline </v-icon>
      </template>

      <template v-slot:header.action="{ header }">
        <div style="float: right; margin-top: 8px">
          <v-menu :close-on-content-click="false" offset-y transition="slide-y-transition" left fixed style="position: absolute; right: 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn small color="indigo" icon v-bind="attrs" v-on="on">
                <v-icon :color="activeFilters['fk_Statut'] && activeFilters['fk_Statut'].length < filters['fk_Statut'].length ? 'red' : 'default'"> mdi-filter-variant</v-icon>
              </v-btn>
            </template>
            <v-list flat dense class="mt-0 mb-0 pt-0 pb-0">
              <v-list-item-group multiple v-model="activeFilters['fk_Statut']" class="py-2">
                <v-list-item v-for="item in filters['fk_Statut']" :key="item.id" :value="item.id">
                  <template v-slot:default="{ active }">
                    <v-list-item-action>
                      <v-list-item-content>
                        <v-checkbox :input-value="active" :true-value="item.id" color="primary"></v-checkbox>
                      </v-list-item-content>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.value"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-list-item-group>
              <v-divider></v-divider>
              <v-row no-gutters>
                <v-col cols="6">
                  <v-btn text block @click="toggleAll('fk_Statut')">Tout activer</v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn text block @click="clearAll('fk_Statut')">Tout effacer</v-btn>
                </v-col>
              </v-row>
            </v-list>
          </v-menu>
        </div>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="IsisExpand">
          <div v-if="item.dateEnvoiMail != ''">
            <v-icon small class="mr-2" title="Email envoyé au fournisseur"> mdi-email </v-icon>
            Envoyé le {{ item.dateEnvoiMail }}
          </div>
          <div>
            <v-icon small class="mr-2" title="Description envoyée"> mdi-arrow-right-thick </v-icon>
            {{ item.descriptif }}
          </div>
          <div>
            <v-icon small class="mr-2" title="Commentaire retour" color="primary"> mdi-arrow-left-thick </v-icon>
            {{ item.commentaireApprobateur }}
          </div>
        </td>
      </template>
    </v-data-table>
    <v-row class="mt-4 mb-3" style="max-width: 98%; margin: 0px auto">
      <v-btn :disabled="selEmpty || !selEngmtsAAppr" color="secondary" title="Envoyer les engagements sélectionnés pour approbation" @click="Fct_StatusEngage">
        Envoyer en Approbation
      </v-btn>
      <v-btn :disabled="selEmpty" color="secondary" title="Envoyer les engagements sélectionnés aux fournisseurs" @click="Fct_StatusSent" class="ml-2">
        Envoyer au fournisseur
      </v-btn>
      <v-btn :disabled="!selSingle" color="secondary" title="Dupliquer l'engagement sélectionné" @click="Fct_DupliquerEngage" class="ml-6">
        Dupliquer
      </v-btn>
      <v-btn :disabled="selEmpty" v-if="B_SuperAdmin" color="#cc0000" style="color: #fff" title="Refuser les engagements sélectionnés" @click="Fct_RefuserEngage" class="ml-2">
        Refuser
      </v-btn>
      <v-btn :disabled="selEmpty" v-if="B_SuperAdmin" color="#cc0000" style="color: #fff" title="Archiver les engagements sélectionnés" @click="Fct_ArchiverEngage" class="ml-2">
        Archiver
      </v-btn>
      <v-btn v-if="B_SuperAdmin" color="secondary" title="Exporter les engagements au format xlsx" @click="Fct_ExportXLSX" class="ml-6">Export excel</v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { MixinProviders } from "../../mixin/MixinProviders";
import { MixinUsers } from "../../mixin/MixinUsers";
import { MixinBudgets } from "../../mixin/MixinBudgets";

import XLSX from "xlsx";

export default {
  mixins: [MixinProviders, MixinUsers, MixinBudgets],
  name: "Engagement",
  data: () => ({
    L_UserID: 0,
    B_SingleSelect: false,
    TO_Selected: [],
    L_Indice: 0,
    T_ErrorUser: "",
    B_Cancel: false,
    L_Limit: 0,
    B_Wait4Engage: false,
    B_Wait4Refuse: false,
    B_Wait4Archive: false,
    L_TimeOut: 10,
    //TO_Headers: [],
    TO_Datalines: [],
    T_Search: "",
    TO_Expanded: [],
    L_TypeStatut: 0,
    B_EngagementLoaded: false,
    B_FactureODALoaded: false,
    TO_BudgetsList: [],
    TO_EngagementsList: [],
    TO_FactureODA: [],
    B_SuperAdmin: false,
    filters: {
      fk_Statut: [
        { id: 1, value: "A approuver" },
        { id: 2, value: "En demande" },
        { id: 3, value: "Approuvé" },
        { id: 4, value: "Refusé" },
        { id: 5, value: "Envoyé" }
      ]
    },
    activeFilters: {}
  }),
  created() {
    var T_SuperAdmin = this.$cookies.get("UserAdmin");
    this.B_SuperAdmin = T_SuperAdmin == "true";
    this.initFilters();
  },
  mounted() {
    // Le DOM est chargé
    this.L_UserID = this.$cookies.get("UserID");
    this.ProvidersLoad();
    this.Fct_UsersLoad();
    this.Fct_Loading();
  },
  computed: {
    headers() {
      return [
        { text: "Date de création", align: "left", value: "dateEngagement" },
        { text: "Référence interne", align: "left", value: "referenceInterne" },
        { text: "Fournisseur", value: "provider", align: "left" },
        { text: "Emeteur", value: "issuer", align: "left" },
        { text: "Nature Analytique", value: "search_na" },
        { text: "Libellé", value: "libelle" },
        { text: "Montant Engagé", value: "montantTotal", align: "left" },
        { text: "Facturé", value: "totalConsomme", align: "right" },
        { text: "Différence", value: "montantdifference", align: "right" },
        { text: "Fichier", value: "file", align: "right" },
        { text: "", value: "action", sortable: false, align: "right" },
        { text: "", value: "data-table-expand" }
      ];
    },
    filteredItems() {
      return this.TO_Datalines.filter(item => this.activeFilters.fk_Statut.includes(item.fk_Statut));
    },
    selEmpty() {
      return this.TO_Selected.length <= 0;
    },
    selSingle() {
      return this.TO_Selected.length == 1;
    },
    selEngmtsAAppr() {
      //1 = A approuver
      var index = 0;
      var limit = this.TO_Selected.length;
      for (index = 0; index < limit; index++) {
        var O_Engage = this.TO_Selected[index];
        if (O_Engage.fk_Statut != 1) {
          return false;
        }
      }
      return true;
    },
    selEngmtsAppr() {
      //3 = Approuvé
      var index = 0;
      var limit = this.TO_Selected.length;
      for (index = 0; index < limit; index++) {
        var O_Engage = this.TO_Selected[index];
        if (this.B_SuperAdmin) {
          if (O_Engage.fk_Statut == 4) {
            return false;
          }
        } else {
          if (O_Engage.fk_Statut != 3) {
            return false;
          }
        }
      }
      return true;
    }
  },
  methods: {
    renderBudgets(budgets) {
      let content = "";
      budgets.forEach((budget, index) => {
        content += `${budget.libelle_nature} (${budget.code_nature}) - ${budget.montant} €`;
        if (index < budgets.length - 1) {
          content += "<br>";
        }
      });
      return content;
    },
    initFilters() {
      this.activeFilters = {
        fk_Statut: this.filters.fk_Statut.map(item => item.id)
      };
    },
    Fct_Loading() {
      // vérifie l'avancement du chargement de la page
      var B_Loaded = false;
      if (!this.ProvidersLoaded) {
        this.T_Message = "Chargement des fournisseurs";
      } else if (!this.B_UsersLoaded) {
        this.T_Message = "Chargement des utilisateurs";
      } else {
        B_Loaded = true;
      }

      if (B_Loaded) {
        this.Fct_Launch();
        this.T_Message = "";
      } else {
        setTimeout(this.Fct_Loading, 500);
      }
    },
    Fct_Launch() {
      var T_CookiePeriod = this.$cookies.get("Period");
      var T_CookieAnalyticalAccountCode = this.$cookies.get("AnalyticalAccountCode");
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .post("engagements/engaglist/", { period: T_CookiePeriod, analyticalAccountCode: T_CookieAnalyticalAccountCode }, { headers: { Authorization: T_Token } })
        .then(O_Response => {
          this.TO_Datalines = [];
          if (O_Response.data != "") {
            for (var L_Index = 0; L_Index < O_Response.data.length; L_Index++) {
              O_Response.data[L_Index].provider = "Provider";
              O_Response.data[L_Index].user = "User";
              O_Response.data[L_Index].issuer = "Issuer";
              O_Response.data[L_Index].search_ca = O_Response.data[L_Index].libelle_CA + " " + O_Response.data[L_Index].code_CA;
              O_Response.data[L_Index].dateLivraison = this.IsisFct_Date2Display(O_Response.data[L_Index].dateLivraison);
              O_Response.data[L_Index].montantdifference = O_Response.data[L_Index].montantTotal - O_Response.data[L_Index].totalConsomme;
              O_Response.data[L_Index].dateEnvoiMail = this.IsisFct_Date2Display(O_Response.data[L_Index].dateEnvoiMail);
              O_Response.data[L_Index].dateEngagement = this.IsisFct_Date2Display(O_Response.data[L_Index].dateEngagement);

              //O_Response.data[L_Index].search_na = O_Response.data[L_Index].libelle_nature + " " + O_Response.data[L_Index].code_nature;
              O_Response.data[L_Index].search_na = "";
              for (var L_Index2 = 0; L_Index2 < O_Response.data[L_Index].budgets.length; L_Index2++) {
                var budget = O_Response.data[L_Index].budgets[L_Index2];
                if (L_Index2 > 0) O_Response.data[L_Index].search_na += " ";
                O_Response.data[L_Index].search_na += budget.libelle_nature + " " + budget.code_nature;
              }

              this.TO_Datalines.push(O_Response.data[L_Index]);
            }
          }
          this.Fct_AssociateProviders();
          this.Fct_AssociateUsers();
        })
        .catch(() => {
          this.$router.push({ name: "Disconnect" });
        });
    },
    Fct_AssociateProviders() {
      // associer les fournisseurs aux lignes d'engagements
      var TO_Providers = this.ProvidersList;
      var O_ProvidersList = {};

      var L_Index;
      for (L_Index = 0; L_Index < TO_Providers.length; L_Index++) {
        var O_Provider = TO_Providers[L_Index];
        O_ProvidersList[O_Provider.id] = O_Provider.company_name;
      }

      for (L_Index = 0; L_Index < this.TO_Datalines.length; L_Index++) {
        this.TO_Datalines[L_Index].provider = O_ProvidersList[this.TO_Datalines[L_Index].fk_Fournisseur];
      }
    },
    Fct_AssociateUsers() {
      // associer les utilisateurs aux lignes d'engagements
      var TO_UsersList = {};

      var L_Index;
      for (L_Index = 0; L_Index < this.TO_UsersList.length; L_Index++) {
        var O_User = this.TO_UsersList[L_Index];
        TO_UsersList[O_User.id] = O_User.last_name + " " + O_User.first_name;
      }

      for (L_Index = 0; L_Index < this.TO_Datalines.length; L_Index++) {
        this.TO_Datalines[L_Index].user = TO_UsersList[this.TO_Datalines[L_Index].fk_UserEngagement];
        this.TO_Datalines[L_Index].issuer = TO_UsersList[this.TO_Datalines[L_Index].fk_UserIssuer];
      }
    },
    Fct_AddEngage() {
      this.$router.push({ name: "Engagement-Add" });
    },
    Fct_EditEngage(L_ID) {
      window.location = "/engagement/edit/" + L_ID;
    },
    Fct_VisuEngage(L_ID) {
      window.location = "/engagement/edit/" + L_ID;
    },
    Fct_OpenFile(T_File) {
      if (T_File) {
        window.open(T_File, "_blank");
      }
    },
    Fct_StatusEngage() {
      const self = this;
      if (this.B_Wait4Engage) {
        alert("Un envoi est en cours. Veuillez patienter");
      } else {
        this.L_Limit = this.TO_Selected.length;
        this.L_Indice = 0;
        this.L_TypeStatut = 2;

        if (this.L_Limit == 0) {
          alert("Veuillez sélectionner au moins un engagement");
        } else {
          this.$root.$children[0]
            .IsisConfirm("Confirmez-vous l'envoi de " + this.L_Limit + " engagement(s) pour approbation ?", "", "Valider", "Annuler")
            .then(function(O_Response) {
              if (O_Response) {
                // l'utilisateur a validé
                self.B_Wait4Engage = true;
                self.L_TimeOut = 10;
                self.T_ErrorUser = "";
                self.B_Cancel = false;
                self.Fct_CheckStatusEngage();

                var L_Index;
                for (L_Index = 0; L_Index < self.L_Limit; L_Index++) {
                  var O_Engage = self.TO_Selected[L_Index];
                  if (O_Engage.fk_Statut == 1) {
                    let formData = new FormData();
                    formData.append("fk_Statut", 2);

                    var T_Token = "JWT " + self.$cookies.get("BackEndToken");
                    self.$BackEndAPI
                      .patch("engagements/" + O_Engage.id + "/", formData, { headers: { Authorization: T_Token } })
                      .then(function() {
                        self.L_Indice++;
                      })
                      .catch(T_Error => {
                        self.T_ErrorUser = T_Error;
                        self.L_Indice++;
                      });
                  } else {
                    // ne rien faire
                    self.L_Indice++;
                  }
                }
              } else {
                // l'utilisateur a annulé
                self.B_Cancel = true;
                self.L_Indice++;
              }
            });
        }
      }
    },
    Fct_StatusSent() {
      const self = this;
      if (this.B_Wait4Engage) {
        alert("Un envoi est en cours. Veuillez patienter");
      } else {
        this.L_Limit = this.TO_Selected.length;
        this.L_Indice = 0;
        this.L_TypeStatut = 5;

        if (this.L_Limit == 0) {
          alert("Veuillez sélectionner au moins un engagement");
        } else {
          this.$root.$children[0]
            .IsisConfirm("Confirmez-vous l'envoi de " + this.L_Limit + " email(s) au(x) fournisseur(s) ?", "", "Valider", "Annuler")
            .then(function(O_Response) {
              if (O_Response) {
                // l'utilisateur a validé
                self.B_Wait4Engage = true;
                self.L_TimeOut = 10;
                self.T_ErrorUser = "";
                self.B_Cancel = false;
                self.Fct_CheckSendMail();

                var L_Index;
                for (L_Index = 0; L_Index < self.L_Limit; L_Index++) {
                  var O_Engage = self.TO_Selected[L_Index];
                  if (O_Engage.fk_Statut != 4) {
                    var T_Token = "JWT " + self.$cookies.get("BackEndToken");
                    self.$BackEndAPI
                      .get("engagements/engmtsendmailfrn/" + O_Engage.id + "/", { headers: { Authorization: T_Token } })
                      .then(function() {
                        self.L_Indice++;
                      })
                      .catch(T_Error => {
                        self.T_ErrorUser = T_Error;
                        self.L_Indice++;
                      });
                  } else {
                    // ne rien faire
                    self.L_Indice++;
                  }
                }
              } else {
                // l'utilisateur a annulé
                self.B_Cancel = true;
                self.L_Indice++;
              }
            });
        }
      }
    },
    Fct_CheckStatusEngage() {
      if (this.L_Indice < this.L_Limit) {
        this.L_TimeOut -= 1;
        if (this.L_TimeOut > 0) {
          setTimeout(this.Fct_CheckStatusEngage, 1000);
        }
      } else {
        if (this.T_ErrorUser == "") {
          if (this.B_Cancel == false) {
            if (this.L_TypeStatut == 2) {
              this.$root.$children[0].IsisInfo("Les engagements ont été envoyés pour approbation", "success");
            }
            if (this.L_TypeStatut == 4) {
              this.$root.$children[0].IsisInfo("Les engagements ont été refusés", "success");
            }
          }
        } else {
          this.$root.$children[0].IsisInfo(this.T_ErrorUser, "error");
        }
        this.T_ErrorUser = "";
        this.Fct_Launch();
        this.B_Wait4Engage = false;
        this.B_Wait4Refuse = false;
      }
    },
    Fct_CheckSendMail() {
      if (this.L_Indice < this.L_Limit) {
        this.L_TimeOut -= 1;
        if (this.L_TimeOut > 0) {
          setTimeout(this.Fct_CheckSendMail, 1000);
        }
      } else {
        if (this.T_ErrorUser == "") {
          if (this.B_Cancel == false) {
            this.$root.$children[0].IsisInfo("Les engagements ont été envoyés aux fournisseurs", "success");
          }
        } else {
          this.$root.$children[0].IsisInfo(this.T_ErrorUser, "error");
        }
        this.T_ErrorUser = "";
        this.Fct_Launch();
        this.B_Wait4Engage = false;
        this.B_Wait4Refuse = false;
      }
    },
    Fct_GetEngagements() {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("engagements/?ordering=referenceInterne", { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          this.TO_EngagementsList = [];
          if (TO_Response.data != "") {
            this.TO_EngagementsList = TO_Response.data;
          }
          this.B_EngagementLoaded = true;
        })
        .catch(() => {
          this.$root.$children[0].IsisInfo("Une erreur est survenue lors de la récupération des engagements", "error");
        });
    },
    Fct_GetFact() {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      this.$BackEndAPI
        .get("engagements/getfact/", { headers: { Authorization: T_Token } })
        .then(TO_Response => {
          this.TO_FactureODA = [];
          if (TO_Response.data != "") {
            this.TO_FactureODA = TO_Response.data.data;
          }
          this.B_FactureODALoaded = true;
        })
        .catch(() => {
          this.$root.$children[0].IsisInfo("Une erreur est survenue lors de la récupération des factures (ODA)", "error");
        });
    },
    Fct_GetAutorisationByUser(idUser) {
      this.BudgetsLoadByUser(idUser);
    },
    Fct_ExportXLSX() {
      this.B_BudgetsLoaded = false;
      this.B_EngagementLoaded = false;
      this.B_FactureODALoaded = false;
      //this.TO_BudgetsList = this.BudgetsGet();
      this.Fct_GetAutorisationByUser(this.L_UserID);
      this.Fct_GetEngagements();
      this.Fct_GetFact();
      this.Fct_LoadingXLSX();
    },
    Fct_LoadingXLSX() {
      var B_LoadedDataXLSX = false;
      if (this.B_BudgetsLoaded && this.B_EngagementLoaded && this.B_FactureODALoaded) {
        B_LoadedDataXLSX = true;
      }
      if (B_LoadedDataXLSX) {
        this.Fct_CreateXLSX();
      } else {
        setTimeout(this.Fct_LoadingXLSX, 500);
      }
    },
    Fct_CreateXLSX() {
      //création de la feuille de récap
      var TO_FicRecap = [];

      for (var i = 0; i < this.TO_BudgetsList.length; i++) {
        var R_MontantEngage = 0;
        var R_MontantFactApprouve = 0;
        for (var j = 0; j < this.TO_EngagementsList.length; j++) {
          var budgets = this.TO_EngagementsList[j].budgets;
          for (var k = 0; k < budgets.length; k++) {
            if (budgets[k].fk_budget == this.TO_BudgetsList[i].id) {
              if (this.TO_EngagementsList[j].fk_Statut != 4) {
                //4 = Refusé
                R_MontantEngage += parseFloat(budgets[k].montant);
                R_MontantFactApprouve += parseFloat(budgets[k].consomme);
              }
            }
          }
        }

        var EcrartSurBudget = this.TO_BudgetsList[i].montant - R_MontantEngage;
        var FAR = R_MontantEngage - R_MontantFactApprouve;

        TO_FicRecap.push({
          "Code analytique": this.TO_BudgetsList[i].cpteAnalytique,
          "Code nature": this.TO_BudgetsList[i].natureAnalytique,
          "Libellé nature ": this.TO_BudgetsList[i].libelle_nature,
          "Montant budget": parseFloat(this.TO_BudgetsList[i].montant),
          "Total engagé": R_MontantEngage,
          "Total facturé": R_MontantFactApprouve,
          "Ecart sur budget (C-D)": EcrartSurBudget,
          "F.A.R (E-F)": FAR
        });
      }

      //création de la feuille de détail
      var TO_Detail = [];

      for (i = 0; i < this.TO_EngagementsList.length; i++) {
        budgets = this.TO_EngagementsList[i].budgets;
        for (k = 0; k < budgets.length; k++) {
          for (j = 0; j < this.TO_BudgetsList.length; j++) {
            if (budgets[k].fk_budget == this.TO_BudgetsList[j].id) {
              //ARDL02-56
              TO_Detail.push({
                "Code analytique": this.TO_EngagementsList[i].code_CA,
                "Code nature": budgets[k].code_nature,
                "Libellé nature": budgets[k].libelle_nature,
                Status: this.TO_EngagementsList[i].libelle_statut,
                "Code frn": this.TO_EngagementsList[i].code_frn,
                "Nom frn": this.TO_EngagementsList[i].nom,
                "Mail frn": this.TO_EngagementsList[i].mailFrn,
                "Reference interne": this.TO_EngagementsList[i].referenceInterne,
                "Libellé engagement": this.TO_EngagementsList[i].libelle,
                "Date engagement": this.TO_EngagementsList[i].dateEngagement,
                Montant: parseFloat(budgets[k].montant),
                "Hors budget": this.TO_EngagementsList[i].horsBudget,
                "Date de livraison": this.TO_EngagementsList[i].dateLivraison,
                "Date de reprise": this.TO_EngagementsList[i].dateReprise,
                "Montant facturé": parseFloat(budgets[k].consomme),
                Archive: this.TO_EngagementsList[i].archive
              });
            }
          }
        }
      }

      const data = XLSX.utils.json_to_sheet(TO_FicRecap);
      const data_detail = XLSX.utils.json_to_sheet(TO_Detail);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "Recap");
      XLSX.utils.book_append_sheet(wb, data_detail, "Detail");
      XLSX.writeFile(wb, "export_engagements.xlsx");
    },
    Fct_DupliquerEngage() {
      if (this.TO_Selected.length == 1) {
        var O_Engage = this.TO_Selected[0];
        this.$router.push({
          name: "Engagement-Add",
          query: { duplicata: O_Engage.id }
        });
      }
    },
    Fct_RefuserEngage() {
      const self = this;
      if (this.B_Wait4Refuse) {
        alert("La procédure est en cours. Veuillez patienter");
      } else {
        this.L_Limit = this.TO_Selected.length;
        this.L_Indice = 0;
        this.L_TypeStatut = 4;

        if (this.L_Limit == 0) {
          alert("Veuillez sélectionner au moins un engagement");
        } else {
          this.$root.$children[0].IsisConfirm("Confirmez-vous le refus de " + this.L_Limit + " engagement(s) ?", "", "Valider", "Annuler").then(function(O_Response) {
            if (O_Response) {
              // l'utilisateur a validé
              self.B_Wait4Refuse = true;
              self.L_TimeOut = 10;
              self.T_ErrorUser = "";
              self.B_Cancel = false;
              self.Fct_CheckStatusEngage();

              var L_Index;
              for (L_Index = 0; L_Index < self.L_Limit; L_Index++) {
                var O_Engage = self.TO_Selected[L_Index];
                if (O_Engage.fk_Statut != 4) {
                  let formData = new FormData();
                  formData.append("fk_Statut", 4); // Refusé

                  var T_Token = "JWT " + self.$cookies.get("BackEndToken");
                  self.$BackEndAPI
                    .patch("engagements/" + O_Engage.id + "/", formData, { headers: { Authorization: T_Token } })
                    .then(function() {
                      self.L_Indice++;
                    })
                    .catch(T_Error => {
                      self.T_ErrorUser = T_Error;
                      self.L_Indice++;
                    });
                } else {
                  // ne rien faire
                  self.L_Indice++;
                }
              }
            } else {
              // l'utilisateur a annulé
              self.B_Cancel = true;
              self.L_Indice++;
            }
          });
        }
      }
    },
    Fct_ArchiverEngage() {
      const self = this;
      if (this.B_Wait4Archive) {
        alert("La procédure est en cours. Veuillez patienter");
      } else {
        this.L_Limit = this.TO_Selected.length;
        this.L_Indice = 0;
        //this.L_TypeStatut = ?;

        if (this.L_Limit == 0) {
          alert("Veuillez sélectionner au moins un engagement");
        } else {
          this.$root.$children[0].IsisConfirm("Confirmez-vous l'archivage de " + this.L_Limit + " engagement(s) ?", "", "Valider", "Annuler").then(function(O_Response) {
            if (O_Response) {
              // l'utilisateur a validé
              self.B_Wait4Archive = true;
              self.L_TimeOut = 10;
              self.T_ErrorUser = "";
              self.B_Cancel = false;
              self.Fct_CheckStatusArchive();

              var L_Index;
              for (L_Index = 0; L_Index < self.L_Limit; L_Index++) {
                var O_Engage = self.TO_Selected[L_Index];
                let formData = new FormData();
                formData.append("archive", !O_Engage.archive);

                var T_Token = "JWT " + self.$cookies.get("BackEndToken");
                self.$BackEndAPI
                  .patch("engagements/" + O_Engage.id + "/", formData, { headers: { Authorization: T_Token } })
                  .then(function() {
                    self.L_Indice++;
                  })
                  .catch(T_Error => {
                    self.T_ErrorUser = T_Error;
                    self.L_Indice++;
                  });
              }
            } else {
              // l'utilisateur a annulé
              self.B_Cancel = true;
              self.L_Indice++;
            }
          });
        }
      }
    },
    Fct_CheckStatusArchive() {
      if (this.L_Indice < this.L_Limit) {
        this.L_TimeOut -= 1;
        if (this.L_TimeOut > 0) {
          setTimeout(this.Fct_CheckStatusArchive, 1000);
        }
      } else {
        if (this.T_ErrorUser == "") {
          if (this.B_Cancel == false) {
            this.$root.$children[0].IsisInfo("Les engagements ont été archivés", "success");
          }
        } else {
          this.$root.$children[0].IsisInfo(this.T_ErrorUser, "error");
        }
        this.T_ErrorUser = "";
        this.Fct_Launch();
        this.B_Wait4Archive = false;
      }
    },
    toggleAll(col) {
      const allValues = this.filters[col].map(item => item.id);
      if (this.activeFilters[col].length === allValues.length) {
        this.activeFilters[col] = [];
      } else {
        this.activeFilters[col] = [...allValues];
      }
    },
    clearAll(col) {
      this.activeFilters[col] = [];
    }
  }
};
</script>

<style scoped>
.IsisExpand {
  box-shadow: none;
  background: rgb(242, 244, 249);
}
.v-list--dense .v-list-item,
.v-list-item--dense {
  min-height: 20px !important;
  height: 2rem;
}
</style>
